import React, { useEffect, useState } from "react";
// import numeros_a_letras from "numeros_a_letras";
import numeros from "numeros_a_palabras";
import Print from './print';

const Preview = (props) => {

  const [editable, setEditable] = useState(false);
  const [show, setShow] = useState(false);
  const [cantidad, setCantidad] = useState(0);
  const [cantidadLetra, setCantidadLetra] = useState('');
  const [cifra, setCifra] = useState(0);
  const [cantidadLetradividida, setCantidadLetradividida] = useState('');

  const [abrir, setAbrir] = useState(false);

  var curr = new Date();
  curr.setDate(curr.getDate());
  // var date = curr.toISOString().substring(0,10);

  const [date, setdate] = useState(curr.toISOString().substring(0,10));


  useEffect(() => {

    const obtenerDatos = async() => {
      setCantidad(parseInt(props.cantidad).toLocaleString())
      setCantidadLetra(props.cantidadLetra)
      setCifra(parseInt(props.cantidad * .03).toLocaleString())
      
      numeros.numero2word().Config._setSingular("PESO");
      numeros.numero2word().Config._setPlural("PESOS");


          
    // const letra = numeros.numero2word(numero).toString().replace("MIL", ' MIL ').toUpperCase()
    // var nueva = letra.replace('MIL LONES', 'MILLONES')
    // var nueva2 = nueva.replace('MIL LON', 'MILLON')

    const letra = numeros.numero2word(parseInt(props.cantidad * .03), 'entero', 2).toString().replace("MIL", ' MIL ').toUpperCase()
    var nueva = letra.replace('MIL LONES', 'MILLONES')
    var nueva2 = nueva.replace('MIL LON', 'MILLON')

      setCantidadLetradividida(nueva2)

      setAbrir(false)
    }
    obtenerDatos();
  }, []);

  function handleCantidad(e) {
    console.log(e.target.value);
    setCantidad(e.target.value);
  }
  function handleCantidadLetra(e) {
    setCantidadLetra(e.target.value);
  }
  function handleCantidadInteres(e) {
    setCifra(e.target.value);
  }
  function handleTextoInteres(e) {
    setCantidadLetradividida(e.target.value);
  }
  function handleDateChange(e) {
    setdate(e.target.value);
  }
  

  if (abrir == false) {
    return (
      <button
        onClick={() => { setShow(true); setAbrir(true); }}
        style={{
          marginTop: '1.25rem',
          padding: '0.65rem 1.5rem',
          background: 'linear-gradient(135deg, #2b6cb0, #2c5282)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '0.9rem',
          fontWeight: 500,
          fontFamily: 'Poppins, sans-serif',
          cursor: 'pointer',
        }}
      >
        Generar documento
      </button>
    );
  }
  else{
    if(cantidad === 'NaN')
    {
      setCantidad(parseInt(props.cantidad).toLocaleString())
      setCantidadLetra(props.cantidadLetra)
      setCifra(parseInt(props.cantidad * .03).toLocaleString())
      
      numeros.numero2word().Config._setSingular("PESO");
      numeros.numero2word().Config._setPlural("PESOS");
      
       const letra = numeros.numero2word(parseInt(props.cantidad * .03), 'entero', 2).toString().replace("MIL", ' MIL ').toUpperCase()
        var nueva = letra.replace('MIL LONES', 'MILLONES')
        var nueva2 = nueva.replace('MIL LON', 'MILLON')

      setCantidadLetradividida(nueva2)
    }
    if(cantidad === '')
    {
      setCantidad(parseInt(props.cantidad).toLocaleString())
      setCantidadLetra(props.cantidadLetra)
      setCifra(parseInt(props.cantidad * .03).toLocaleString())
      numeros.numero2word().Config._setSingular("PESO");
      numeros.numero2word().Config._setPlural("PESOS");

      const letra = numeros.numero2word(parseInt(props.cantidad * .03), 'entero', 2).toString().replace("MIL", ' MIL ').toUpperCase()
      var nueva = letra.replace('MIL LONES', 'MILLONES')
      var nueva2 = nueva.replace('MIL LON', 'MILLON')

      setCantidadLetradividida(nueva2)
    }
    
    console.log('pruebas');
    console.log(cantidad);
  
  const field = (label, value, handler, readOnly) => (
    <div key={label} style={{ marginBottom: '0.75rem' }}>
      <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
        {label}
      </div>
      <input
        type="text"
        value={value}
        readOnly={readOnly}
        onChange={handler || undefined}
        style={{
          width: '100%', padding: '0.5rem 0.75rem', boxSizing: 'border-box',
          border: '1px solid #e2e8f0', borderRadius: '6px',
          fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif',
          background: readOnly ? '#f7fafc' : '#fff', color: '#2d3748',
        }}
      />
    </div>
  );

  return (
    <>
      {/* Backdrop */}
      <div style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.45)',
        zIndex: 1000,
      }} onClick={() => { setShow(false); setAbrir(false); setCantidad(''); }} />

      {/* Dialog */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1001,
        background: '#fff', borderRadius: '12px',
        width: '90%', maxWidth: '480px', maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
        fontFamily: 'Poppins, sans-serif',
      }}>
        {/* Header */}
        <div style={{ padding: '1.25rem 1.5rem', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 600, fontSize: '1rem', color: '#1a202c' }}>¿Datos correctos?</span>
          <button onClick={() => { setShow(false); setAbrir(false); setCantidad(''); }}
            style={{ border: 'none', background: 'none', fontSize: '1.25rem', cursor: 'pointer', color: '#718096', lineHeight: 1 }}>
            ×
          </button>
        </div>

        {/* Body */}
        <div style={{ padding: '1.25rem 1.5rem' }}>
          {field('Cliente',             props.cliente.name,    null,                true)}
          {field('Cantidad a prestar',  cantidad,              handleCantidad,      true)}
          {field('Cantidad en letra',   cantidadLetra,         handleCantidadLetra, editable)}
          {field('Intereses',           cifra,                 handleCantidadInteres, editable)}
          {field('Intereses en letra',  cantidadLetradividida, handleTextoInteres,  editable)}

          <div style={{ marginBottom: '0.75rem' }}>
            <div style={{ fontSize: '0.72rem', fontWeight: 600, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '0.25rem' }}>
              Fecha del préstamo
            </div>
            <input type="date" defaultValue={date} onChange={handleDateChange}
              style={{
                width: '100%', padding: '0.5rem 0.75rem', boxSizing: 'border-box',
                border: '1px solid #e2e8f0', borderRadius: '6px',
                fontSize: '0.875rem', fontFamily: 'Poppins, sans-serif', color: '#2d3748',
              }}
            />
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: '1rem 1.5rem', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: '0.75rem' }}>
          <button onClick={() => { setShow(false); setAbrir(false); setCantidad(''); }}
            style={{
              padding: '0.55rem 1.1rem', border: '1px solid #cbd5e0', borderRadius: '7px',
              background: '#fff', color: '#4a5568', fontSize: '0.875rem',
              fontFamily: 'Poppins, sans-serif', cursor: 'pointer',
            }}>
            Cancelar
          </button>
          <Print
            cliente={props.cliente}
            cantidad={cantidad}
            cantidadLetra={cantidadLetra}
            cantidadPagares={props.cantidadPagares}
            avalDomicilio1={props.avalDomicilio1}
            avalDomicilio2={props.avalDomicilio2}
            avalNombre1={props.avalNombre1}
            avalNombre2={props.avalNombre2}
            avales={props.avales}
            fechaPrestamo={date}
          />
        </div>
      </div>
    </>
  );
  }

}


export default Preview;

// SHIFT + ALT + F 